import { combineReducers } from 'redux';
import CounterReducer from './CounterReducer'
import LoginReducer from './LoginReducer';
import UserReducer from './UserReducer'
import ClinicReducer from './ClinicReducer'
import MessagesReducers from './MessageReducers'
import NavReducer from './NavReducer';
import ModalReducer from './ModalReducer';
import FilterReducer from './FilterReducer';


export default combineReducers({
  counter: CounterReducer,
    user: UserReducer,
    login: LoginReducer,
    clinic: ClinicReducer,
    message: MessagesReducers,
    modal: ModalReducer,
    filter: FilterReducer,
    // admin: AdminReducer,
    nav: NavReducer
});